"use client";

import { useEffect, useState } from "react";

import {
  readClientLastSeenUpdateId,
  shouldShowUpdatesBanner,
  writeClientLastSeenUpdateId,
} from "#/lib/updatesSeen";

type UseUpdatesBannerVisibilityOptions = {
  latestUpdateId: string;
  serverLastSeenUpdateId: string | null;
};

export function useUpdatesBannerVisibility({
  latestUpdateId,
  serverLastSeenUpdateId,
}: UseUpdatesBannerVisibilityOptions): { ready: boolean; visible: boolean } {
  const [visible, setVisible] = useState(false);
  const [ready, setReady] = useState(true);

  useEffect(() => {
    if (serverLastSeenUpdateId) {
      writeClientLastSeenUpdateId(serverLastSeenUpdateId);
    }

    setVisible(
      shouldShowUpdatesBanner({
        latestUpdateId,
        lastSeenUpdateId: serverLastSeenUpdateId ?? readClientLastSeenUpdateId(),
      }),
    );
    setReady(true);
  }, [latestUpdateId, serverLastSeenUpdateId]);

  return { ready, visible };
}
